export default __webpack_public_path__ + "static/media/IMG_3634.c1927513.png";